<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>
                            Tra cứu, tìm kiếm duyệt người dùng
                        </strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Tên tài khoản:"
                                              label-for="username"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="username"
                                                  placeholder="Nhập tài khoản ..."
                                                  v-model="searchForm.username">
                                    </b-form-input>
                                </b-form-group>
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" v-model="searchForm.syncSourceType" :options="listSyncSourceTypes"
                                                      allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đơn vị công tác:"
                                              label-for="unit"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption" ref="unitTree"></unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Loại tài khoản:"
                                              label-for="account_type"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 placeholder="--- Tất cả ---"
                                             v-model="searchForm.isExploitingUser"
                                             v-bind:options="listAccountType"
                                             allowClear></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Trạng thái duyệt:"
                                              label-for="user_status"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 placeholder="--- Tất cả ---"
                                             v-model="searchForm.isApproved"
                                             v-bind:options="listUserStatus"
                                             allowClear></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Lý do từ chối:"
                                              label-for="rejectReason"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="rejectReason"
                                                  placeholder="Nhập lý do từ chối ..."
                                                  v-model="searchForm.rejectReason">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-button type="submit" variant="primary" class="offset-md-5">Tìm kiếm</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                    <br />
                    <b-modal :no-enforce-focus="true" :id="infoModal.id" :title="infoModal.title" @hidden="resetModal">
                        <b-row>
                            <b-col>
                                <b-form-group label="Lý do từ chối:"
                                              label-for="rejectReason"
                                              label-cols-md="4"
                                              label-class="required"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-textarea id="rejectReason" type="text" placeholder="Nhập lý do từ chối" rows="3"
                                                  v-model="$v.infoModal.content.$model"
                                                  @input="$v.infoModal.content.$touch"
                                                  :state="$v.infoModal.content.$dirty? !$v.infoModal.content.$error : null">
                                    </b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.infoModal.content.required">
                                        Lý do không được để trống !
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <template #modal-footer="{ cancel, hide }">
                            <b-button type="button" variant="danger" @click="rejectUser()">
                                Từ chối
                            </b-button>
                            <b-button type="button" variant="secondary" @click="cancel()">
                                Hủy
                            </b-button>
                        </template>
                    </b-modal>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="users/list-approved"
                            gridName="Danh sách người dùng"
                            ref="approveUserTable">
                        <!--<template v-slot:actions v-if="authorize(['ManageUser', 'ManageSyncUser', 'ManageExploitationUsers'])">
                            <b-button size="md" @click.stop="approvedUsers" variant="primary" :disabled="isShowBtnDelete">
                                Duyệt
                            </b-button>
                        </template>-->
                        <template v-slot:cell(isApproved)="row">
                            {{ row.item.isApproved == null ? 'Chờ duyệt' : row.item.isApproved == true ? 'Đã duyệt' : 'Từ chối' }}
                        </template>
                        <template v-slot:cell(rejectReason)="row">
                            {{ row.item.isApproved == true || row.item.isApproved == null ? '' : row.item.rejectReason }}
                        </template>
                        <template v-slot:cell(isExploitingUser)="row">
                            {{ row.item.isExploitingUser == true ? 'Tài khoản khai thác' : 'Tài khoản người dùng'}}
                        </template>
                        <template v-slot:cell(roles)="row">
                            {{ row.item.roles.join(', ') }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" :to="{ path: (row.item.isExploitingUser != null && row.item.isExploitingUser != 0) ? `/system/exploitation-users/${row.item.id}/detail?approved=` : `/system/users/${row.item.id}/detail` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template v-if="authorize(['ManageSyncUser']) && row.item.isApproved == null">
                                    <b-button size="sm" @click.stop="approvedUser(row.item, row.index, $event.target)" title="duyệt" variant="primary">
                                        Duyệt
                                    </b-button>
                                    <b-button size="sm" @click.stop="openRejecteReasonModal(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Từ chối
                                    </b-button>
                                    <!--<b-button size="sm" :to="{ path: `./${row.item.id}/privileges` }" title="phân quyền">
                    <i class="fa fa-cogs" aria-hidden="true"></i>
                </b-button>-->
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>

    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'ListSyncUser',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    username: null,
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    isExploitingUser: null,
                    isApproved: "0",
                    rejectReason: null,
                    syncSourceType: this.getSyncSourceTypeCache(),
                },
                listAccountType: [
                    { id: "0", text: 'Tài khoản người dùng' },
                    { id: "1", text: 'Tài khoản khai thác' },
                ],
                listUserStatus: [
                    { id: "0", text: 'Chờ duyệt' },
                    { id: "1", text: 'Từ chối' },
                    { id: "2", text: 'Đã duyệt' },
                ],
                gridOptions: {
                    fields: [
                        { key: 'username', label: 'Tên tài khoản', sortable: true, sortDirection: 'asc' },
                        { key: 'fullName', label: 'Họ tên', sortable: true },
                        { key: 'unitName', label: 'Đơn vị công tác', sortable: true, tdAttr: (key, value, item) => ({ title: item.unitFullName }) },
                        { key: 'isExploitingUser', label: 'Loại tài khoản', sortable: false },
                        { key: 'isApproved', label: 'Trạng thái duyệt', sortable: false },
                        { key: 'rejectReason', label: 'Lý do từ chối' }
                    ],
                    sortBy: 'userName',
                },
                infoModal: {
                    id: 'reject-reason-modal',
                    title: null,
                    content: null,
                    userId: null
                },
                statuses: [
                    { id: 1, text: 'active' },
                    { id: 0, text: 'inactive' }
                ],
                isShowBtnDelete: true,
            }
        },
        validations: {
            infoModal: {
                content: { required },
            }
        },
        computed: {
            ...mapState({
                listSyncSourceTypes: (state) => state.common.listSyncSourceTypes
            })
        },
        created() {
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.approveUserTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.approveUserTable.refresh();
            },
            approvedUser(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn duyệt người dùng này?')) {
                    vm.$services.put(`users/${item.id}/approved`).done(() => {
                        vm.$toastr.s('Duyệt người dùng thành công');
                        vm.search();
                    });
                }
            },
            approvedUsers(item, index, button) {
                var vm = this;
                var selectedRows = vm.$refs.approveUserTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn duyệt những người dùng này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        vm.$services.put(`users/approved?approvedids=${data}`).done(() => {
                            vm.$toastr.s('Duyệt người dùng thành công');
                            vm.search();
                        });
                    }
                } else {
                    vm.$toastr.e('Vui lòng chọn người dùng cần duyệt');
                }
            },
            openRejecteReasonModal(item, index, button) {
                this.infoModal.userId = item.id;
                this.infoModal.title = 'Lý do từ chối tài khoản: ' + item.username;
                this.$root.$emit('bv::show::modal', this.infoModal.id, button);
            },
            resetModal() {
                this.infoModal.content = null;
                this.infoModal.userId = null;
                this.$v.$reset();
            },
            rejectUser() {
                var vm = this;
                vm.$v.$touch();
                if (!vm.$v.$invalid) {
                    vm.$services.put(`users/approved/reject/${vm.infoModal.userId}/${vm.infoModal.content}`).done(() => {
                        vm.$toastr.s('Từ chối người dùng thành công');
                        vm.search();
                        vm.$bvModal.hide(vm.infoModal.id);
                    });
                }
            }
        }
    }
</script>
<style scoped>

    .w30 {
        width: 30px;
    }
</style>
